
let routerAuction = [
  {
    path: '/auctionlogin',
    name: 'auctionlogin',
    meta: {
      title: '竞拍管理',
    },
    component: () => import('../views/Auction/AuctionLogin'),
  },
  {
    path: '/auctionmanage',
    name: 'auctionmanage',
    meta: {
      title: '竞拍管理',
      isCheckAuctionLogin:true
    },
    component: () => import('../views/Auction/AuctionManage'),
  },
  {
    path: '/auctionsearch',
    name: 'auctionsearch',
    meta: {
      title: '搜索',
      isCheckAuctionLogin:true
    },
    component: () => import('../views/Auction/AuctionSearch'),
  },
  {
    path: '/auctionlist',
    name: 'auctionlist',
    meta: {
      title: '竞拍管理',
      isCheckAuctionLogin:true,
      keepAlive:true
    },
    component: () => import('../views/Auction/AuctionList'),
  },
  {
    path: '/auctiondetail',
    name: 'auctiondetail',
    meta: {
      title: '竞拍详情',
      isCheckAuctionLogin:true
    },
    component: () => import('../views/Auction/AuctionDetail'),
  },
]
export default routerAuction